<template>
  <div class="card-item card-item-indoor">
    <icon-building class="icon" v-ifield-b-tooltip="iconTooltipText" />
    <span
      ref="truncTarget"
      class="text ellipsis"
      v-ifield-b-tooltip="tooltipOption"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
import { toRefs } from 'vue'
import IconBuilding from '@/assets/ifield/ic_building.svg?component'
import { useIsTruncated } from '@/composables/UseIsTruncated'
import { useUserStatusAdditionalItemIndoor } from '@/composables/user/additionalItem'

export default {
  name: 'AppCardMemberItemIndoor',
  components: {
    IconBuilding,
  },
  inheritAttrs: false,
  props: {
    /**
     * ビル名
     */
    buildingName: {
      type: String,
      default: null,
    },
    /**
     * ビル短縮名
     */
    buildingShortName: {
      type: String,
      default: null,
    },
    /**
     * フロア名
     */
    levelName: {
      type: String,
      default: null,
    },
    /**
     * フロア短縮名
     */
    levelShortName: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const { buildingName, buildingShortName, levelName, levelShortName } =
      toRefs(props)
    const { truncTarget, isTruncated } = useIsTruncated()
    const { text } = useUserStatusAdditionalItemIndoor({
      buildingName,
      buildingShortName,
      levelName,
      levelShortName,
    })
    return { truncTarget, isTruncated, text }
  },
  computed: {
    /**
     * アイコン部ツールチップテキスト
     * @type {string}
     */
    iconTooltipText: function () {
      return `${this.$t('appCardMemberItemIndoor.building')} (${this.$t(
        'appCardMemberItemIndoor.floor'
      )}) : ${this.text}`
    },
    /**
     * ツールチップオプション
     * @type {Object}
     */
    tooltipOption: function () {
      return {
        title: this.text,
        disabled: !this.isTruncated,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../assets/scss/parts/member/card-member-item';
</style>
